<template>
    <div class="text-center">
        <v-row>
            <v-col>
                <h2>Planverwaltung</h2>
                <v-row align="center">
                    <v-col cols="2">
                        <v-btn icon @click="prevWeek">
                            <v-icon v-text="'mdi-arrow-left-bold-circle-outline'"></v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="8">
                        <span>{{ options }}</span>
                    </v-col>
                    <v-col cols="2">
                        <v-btn icon @click="nextWeek">
                            <v-icon v-text="'mdi-arrow-right-bold-circle-outline'"></v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-data-table
                    :headers="headers"
                    :items="datesToShow"
                    :items-per-page="6"
                    :loading="isLoading"
                    hide-default-footer
                    hide-default-header
                >
                    <template v-slot:item.formattedDate="{ item }">
                        <span class="indigo--text">
                            {{ item.formattedDate }}
                        </span>
                    </template>
                    <template v-slot:item.family="{ item }">
                        <v-row>
                            <v-col xs8>
                                <v-select
                                    v-model="selectedUsers[item.date]"
                                    :items="users"
                                    placeholder="Name"
                                    item-text="name"
                                    item-value="id"
                                />
                            </v-col>
                            <v-col xs4>
                                <v-select
                                    v-model="swappedUsers[item.date]"
                                    :items="users"
                                    placeholder="Tauschname"
                                    item-text="name"
                                    item-value="id"
                                    clearable
                                />
                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn
                    class="mx-2"
                    fab
                    dark
                    large
                    color="cyan"
                    :loading="isSaving"
                    @click="save"
                >
                    <v-icon large>
                        mdi-content-save
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import UserService from '@/services/UserService';
import moment from 'moment';
import PlanService from '@/services/PlanService';

export default {
    name: 'UserPlan',
    data() {
        return {
            headers: [
                {
                    text: 'Datum',
                    align: 'start',
                    sortable: false,
                    value: 'formattedDate',
                },
                {
                    text: 'Familie',
                    align: 'start',
                    sortable: false,
                    value: 'family',
                },
            ],
            isSaving: false,
            isLoading: false,
            users: [],
            selectedUsers: [],
            swappedUsers: [],
            weekIndex: 0
        }
    },
    async created() {
        if (!this.isAdmin) {
            this.$router.push('/')
        }
        this.users = await UserService.getPlanUsers()
        this.getPlans()
    },
    computed: {
        isAdmin() {
            return this.$store.getters.isAdmin
        },
        datesToShow() {
            const days = [];
            for (let i = 0; i <= 5; i++) {
                const date = moment(this.weekStart).add(i, 'days')
                let formattedDate = date
                if (date.weekday() === 5) {
                    formattedDate = `${date.format('dd. DD.MM.')} / ${date.add(1, 'days').format('dd. DD.MM.YYYY')}`
                } else {
                    formattedDate = date.format('dd. DD.MM.YYYY')
                }
                days.push({
                    formattedDate: formattedDate,
                    date: date.format('DD.MM.YYYY')
                })
            }
            return days
        },
        options() {
            return `${this.datesToShow[0].date} - ${this.datesToShow[this.datesToShow.length - 1].date}`
        },
        week() {
            return this.weekStart.week()
        },
        weekStart() {
            return moment().add(this.weekIndex, 'weeks').startOf('week')
        },
        year() {
            return this.weekStart.year()
        },
        plans() {
            const plans = []
            Object.keys(this.selectedUsers).forEach(key => {
                const plan = {
                    upid: this.selectedUsers[key],
                    swapped_upid: this.swappedUsers[key],
                    date: key,
                    week: this.week
                }
                plans.push(plan)
            })
            return plans
        }
    },
    methods: {
        nextWeek() {
            this.weekIndex++
            this.getPlans()
        },
        prevWeek() {
            this.weekIndex--
            this.getPlans()
        },
        async save() {
            this.isSaving = true
            try {
                await PlanService.submitPlan(this.plans)
            } catch (error) {
                console.log('Error :/', error)
            }
            this.isSaving = false
        },
        async getPlans() {
            this.isLoading = true
            try {
                const plans = await PlanService.getPlans(this.week, this.year)
                this.setPreselectedUsers(plans)
            } catch (error) {
                //
            }
            this.isLoading = false
        },
        setPreselectedUsers(plans) {
            plans.forEach(plan => {
                if (this.datesToShow.some(dateToShow => dateToShow.date === plan.date)) {
                    const foundSelectedUserId = this.users.find(user => user.id === plan.upid).id
                    this.$set(this.selectedUsers, plan.date, foundSelectedUserId)
                    if (plan.swapped_upid) {
                        const foundSwappedUserId = this.users.find(user => user.id === plan.swapped_upid).id
                        this.$set(this.swappedUsers, plan.date, foundSwappedUserId)
                    }
                }
            })
        }
    }
}
</script>
